var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { staticClass: "download_other_apps" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        this.domainName == `roborobo.${_vm.institutionConfig.baseDomainName}` ||
        this.domainName == "c.roborobo.cn"
          ? _c("div", { staticClass: "other_app_item" }, [_vm._m(2)])
          : _vm._e(),
        _vm._v(" "),
        this.domainName == `roborobo.${_vm.institutionConfig.baseDomainName}` ||
        this.domainName == "c.roborobo.cn"
          ? _c("div", { staticClass: "other_app_item" }, [_vm._m(3)])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("Foot"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "other_app_item" }, [
      _c(
        "div",
        {
          staticClass: "other_app_item_content appImage",
          staticStyle: {
            "background-image": "url(../../../static/download/chrome.png)",
          },
        },
        [
          _c("span", { staticClass: "other_app_item_title" }, [
            _vm._v("谷歌浏览器"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "other_app_item_download_btn_list" }, [
            _c(
              "a",
              {
                staticClass: "other_app_item_download_btn",
                attrs: {
                  href: "https://download.vipcode.com/software/ChromeStandalone_64.0.3282.119_Setup.exe",
                },
              },
              [_vm._v("windows下载")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "other_app_item_download_btn",
                attrs: {
                  href: "https://download.vipcode.com/software/googlechrome.dmg",
                },
              },
              [_vm._v("Mac下载")]
            ),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "other_app_item" }, [
      _c(
        "div",
        {
          staticClass: "other_app_item_content appImage",
          staticStyle: {
            "background-image": "url(../../../static/download/python.jpg)",
          },
        },
        [
          _c("span", { staticClass: "other_app_item_title" }, [
            _vm._v("Python客户端"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "other_app_item_download_btn_list" }, [
            _c(
              "a",
              {
                staticClass: "other_app_item_download_btn",
                attrs: {
                  href: "https://static-highcoding.oss-cn-zhangjiakou.aliyuncs.com/python-3.8.2.exe",
                },
              },
              [_vm._v("windows下载")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "other_app_item_download_btn",
                attrs: {
                  href: "https://static-highcoding.oss-cn-zhangjiakou.aliyuncs.com/python-3.8.2-macosx10.9.pkg",
                },
              },
              [_vm._v("Mac下载")]
            ),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "other_app_item_content appImage",
        staticStyle: {
          "background-image": "url(../../../static/download/vcpython.png)",
        },
      },
      [
        _c("span", { staticClass: "other_app_item_title" }, [
          _vm._v("VC-Python编译器"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "other_app_item_download_btn_list" }, [
          _c(
            "a",
            {
              staticClass: "other_app_item_download_btn",
              attrs: {
                href: "https://vipcode-client.oss-cn-beijing.aliyuncs.com/Compiler/Release/vcEditer-1.0.0.1.exe",
              },
            },
            [_vm._v("windows下载")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "other_app_item_download_btn",
              attrs: {
                href: "https://vipcode-client.oss-cn-beijing.aliyuncs.com/Compiler/Release/vcEditer-1.0.0.dmg",
              },
            },
            [_vm._v("Mac下载")]
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "other_app_item_content appImage",
        staticStyle: {
          "background-image": "url(../../../static/download/rogic.png)",
        },
      },
      [
        _c("span", { staticClass: "other_app_item_title" }, [_vm._v("Rogic")]),
        _vm._v(" "),
        _c("div", { staticClass: "other_app_item_download_btn_list" }, [
          _c(
            "a",
            {
              staticClass: "other_app_item_download_btn",
              attrs: {
                href: "https://static-highcoding.oss-cn-zhangjiakou.aliyuncs.com/Rogic%202019.6.exe",
              },
            },
            [_vm._v("windows下载")]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/download/download.vue?vue&type=template&id=5714c405&
// module id = null
// module chunks = 